module.exports = "/_next/static/images/5f21cc18c34d0ab5afcbfb38299bdb73-chat-icon.svg";